<template>
  <UiTextInputDropdown
    v-model="domain"
    placeholder="Фильтр по логину"
    :options="options"
    v-on="$listeners"
    @search="onSearch"
    @input="input"
  />
</template>

<script>
import UiTextInputDropdown from '@/components/UiTextInputDropdown.vue'

import debounce from 'lodash/debounce'

import syncQuery from '@/mixins/syncUrlQuery'

import { ApplicationsService } from '@/services/applications.service'

export default {
  components: { UiTextInputDropdown },
  mixins: [syncQuery],
  data() {
    return {
      domain: '',
      options: [],
    }
  },
  mounted() {
    this.domain = this.$route.query.domain
  },
  methods: {
    onSearch(search, loading) {
      if (search.length) {
        loading(true)

        this.search(loading, search, this)
      }
    },
    search: debounce(async (loading, search, vm) => {
      const { data } = await ApplicationsService.getShortList({ domain: search })
      vm.options = data.content.map((app) => app.domain)

      loading(false)
    }, 350),
    input(e) {
      /**
       * Clear value after click `clear` button
       */
      if (e === null) {
        this.domain = null
      }
    },
  },
}
</script>
